/**
 * The theme, read from the document and written back through `applyTheme`.
 *
 * `useSyncExternalStore` rather than `useState`, because the store is `<html>`'s class list and it is
 * already set before React mounts. Holding a second copy in component state is how a toggle ends up
 * disagreeing with the page it is on, and how the first render flashes the wrong theme on a
 * server-rendered or blocking-script-initialised document.
 */
import { useCallback, useSyncExternalStore } from 'react';
import {} from '../tokens/themes.js';
import { applyTheme, readTheme, subscribeToTheme } from './current.js';
export const useTheme = () => {
    // No server snapshot argument, because neither app server-renders. Supplying one would be an
    // untestable guess about a rendering mode this repository does not have; if a later spec adds SSR,
    // React fails loudly at hydration rather than silently rendering the wrong theme.
    const theme = useSyncExternalStore(subscribeToTheme, () => readTheme(document.documentElement));
    const setTheme = useCallback((next) => {
        applyTheme(next);
    }, []);
    const toggleTheme = useCallback(() => {
        applyTheme(readTheme(document.documentElement) === 'dark' ? 'light' : 'dark');
    }, []);
    return { theme, setTheme, toggleTheme };
};
//# sourceMappingURL=useTheme.js.map